import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as CircleM } from "../../../asset/image/cir_message.svg";
import { ReactComponent as CircleP } from "../../../asset/image/cir_people.svg";
import { ReactComponent as CircleC } from "../../../asset/image/cir_chart.svg";
import { ReactComponent as CircleF } from "../../../asset/image/cir_files.svg";

function KpiCard({ to, tone, icon, title, value, meta, loading }) {
    return (
        <Link to={to} className={`dash-info-card info-back-${tone}`}>
            <div className="info-ca-top">
                <div>
                    <div className="circle_s">{icon}</div>
                    <span>{title}</span>
                </div>
                <div className="kpi-value">{loading ? "—" : value}</div>
            </div>
            <div className="info-ca-bottom">
                {meta.map((item) => (
                    <div key={item.label}>
                        <span>{item.label}</span>
                        <span>{loading ? "—" : item.value}</span>
                    </div>
                ))}
            </div>
        </Link>
    );
}

export default function DashHeader({ stats, loading, formatCount }) {
    const { t } = useTranslation();

    return (
        <div className="dashboard-header-main">
            <KpiCard
                to="/dashboard/messages/user"
                tone="me"
                icon={<CircleM />}
                title={t("UserPanel.dashboard.MessagesShowCase.Label")}
                value={formatCount(stats.messages)}
                loading={loading}
                meta={[
                    {
                        label: t("UserPanel.Overview.Kpi.Messages.Meta"),
                        value: formatCount(stats.messages),
                    },
                    {
                        label: t("Organizational.CustomerClub.Members.Metric.Coins"),
                        value: formatCount(stats.messageCoins),
                    },
                ]}
            />
            <KpiCard
                to="/dashboard/user/poll"
                tone="re"
                icon={<CircleC />}
                title={t("Surveys&announcments.label")}
                value={formatCount(stats.surveyPending)}
                loading={loading}
                meta={[
                    {
                        label: t("UserPanel.Overview.Kpi.Surveys.Pending"),
                        value: formatCount(stats.surveyPending),
                    },
                    {
                        label: t("UserPanel.Overview.Kpi.Surveys.Done"),
                        value: formatCount(stats.surveyDone),
                    },
                ]}
            />
            <KpiCard
                to="/dashboard/user/customer-club"
                tone="cl"
                icon={<CircleP />}
                title={t("User.Participations.label")}
                value={formatCount(stats.clubs)}
                loading={loading}
                meta={[
                    {
                        label: t("UserPanel.Overview.Kpi.Clubs"),
                        value: formatCount(stats.clubs),
                    },
                    {
                        label: t("Organizational.CustomerClub.Members.Metric.Ideas"),
                        value: formatCount(stats.ideas),
                    },
                ]}
            />
            <KpiCard
                to="/dashboard/user/discount"
                tone="ra"
                icon={<CircleF />}
                title={t("Offers")}
                value={formatCount(stats.usedCards)}
                loading={loading}
                meta={[
                    {
                        label: t("UserPanel.Overview.Kpi.Bought"),
                        value: formatCount(stats.usedCards),
                    },
                    {
                        label: t("UserPanel.dashboard.Available.Label"),
                        value: formatCount(stats.coins),
                    },
                ]}
            />
        </div>
    );
}
